import getSymbolFromCurrency from 'currency-symbol-map';
import gql from 'graphql-tag';
import { Component } from 'react';
import { withApollo } from 'react-apollo';
import {
	deleteBonus,
	queryBonusByReferralIdIndex,
} from 'src/_shared/api/graphql/custom/bonuses/';
import { deleteReferral } from 'src/_shared/api/graphql/default/mutations';
import Spinner from 'src/_shared/components/spinner/SpinnerComponent.jsx';
import { findWithAttr as findWithAttribute } from '../_shared/services/utils.js';
import DetailsView from './ReferralDetailsViewComponent.jsx';
import { spinContainer } from './referralDetailsStyles.js';

class ReferralDetailsComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			company: props?.currentUser?.company,
			selectedUser: props.currentUser,
			edit: false,
			currencyRate: 1,
			currencySymbol: '$',
		};
	}

	componentDidMount() {
		this.getCurrencyRate(
			this.props.currentUser && this.props.currentUser.currency !== null
				? this.props.currentUser.currency
				: 'USD'
		);
	}

	async getCurrencyRate(currency) {
		const response = await fetch(
			`https://api.exchangeratesapi.io/latest?base=USD&symbols=${currency}`
		);
		const result = await response.json();
		if (result.error) {
			// Make this USD
			this.setState({
				currencyRate: 1,
				currencySymbol: '$',
			});
		} else {
			const rate = result.rates[currency].toFixed(5);
			const symbol = getSymbolFromCurrency(currency);
			this.props.setCurrentCurrencyRate(rate);
			this.props.setCurrentCurrencySymbol(symbol);
			this.setState({
				currencyRate: rate,
				currencySymbol: symbol,
			});
		}
	}

	deleteReferral = (referral) => {
		this.props.client
			.query({
				query: gql(queryBonusByReferralIdIndex),
				variables: {
					referralId: referral?.id,
				},
			})
			.then((data) => {
				const bonuses = data?.data?.queryBonusByReferralIdIndex?.items || [];
				if (bonuses.length > 0) {
					bonuses.forEach(async (bonus) => {
						await this.props.client.mutate({
							mutation: gql(deleteBonus),
							variables: {
								input: {
									id: bonus?.id,
								},
							},
						});
					});
				}

				this.props.client.mutate({
					mutation: gql(deleteReferral),
					variables: {
						input: {
							id: referral?.id,
						},
					},
				});
			});
	};

	render() {
		const {
			allMultiLingualData,
			currentUser,
			location,
			referral,
			companyData,
		} = this.props;
		const parsedOwnershipSettings = JSON.parse(
			companyData?.ownershipSettings || '{}'
		);
		const { company } = this.state;
		if (referral && referral.companyId != currentUser.companyId) {
			return <Spinner company={company} />;
		}

		const { currencyRate, currencySymbol } = this.state;
		const allReferrals = location?.state?.filteredData || [];
		let referralData;

		const socials =
			typeof referral?.contact?.socialMediaAccounts === 'string'
				? JSON.parse(referral?.contact?.socialMediaAccounts || '[]')
				: null;

		if (referral !== undefined) {
			referralData = {
				id: referral?.contact?.id,
				atsId: referral?.atsId,
				referralId: referral?.id,
				adminNote: referral?.adminNote || '',
				bonuses: referral?.bonuses,
				firstName: referral?.contact?.firstName,
				lastName: referral?.contact?.lastName,
				emailAddress: referral?.contact?.emailAddress
					? referral.contact.emailAddress.toLowerCase()
					: null,
				location: 'New York, NY',
				bio: null,
				phone: referral?.contact?.phoneNumber || null,
				companyId: referral?.companyId,
				contactId: referral?.contact?.id,
				contact: referral?.contact,
				department: 'Sales',
				linkedin:
					socials !== null &&
					findWithAttribute(socials, 'network', 'linkedin') >= 0
						? socials[findWithAttribute(socials, 'network', 'linkedin')].profile
						: null,
				facebook:
					socials !== null &&
					findWithAttribute(socials, 'network', 'facebook') >= 0
						? socials[findWithAttribute(socials, 'network', 'facebook')].profile
						: null,
				Twitter:
					socials !== null &&
					findWithAttribute(socials, 'network', 'twitter') >= 0
						? socials[findWithAttribute(socials, 'network', 'twitter')].profile
						: null,
				employment: [],
				allReferrals,
				referrals: referral?.contact?.referrals,
				referralType: referral?.referralType || 'standard',
				incentiveEligible: referral?.user?.incentiveEligible,
				job: referral?.job,
				jobId: referral?.jobId,
				socialMediaAccounts: socials,
				status: referral?.status,
				bonusStatus: referral?.bonusStatus,
				user: referral?.user,
				userId: referral?.userId,
				hireDate: referral?.hireDate,
				onDeckStatus: referral?.contact?.onDeckStatus,
				onDeckDate: referral?.contact?.onDeckDate,
				contactResume:
					referral?.contactResume === null
						? referral?.contact?.contactResume || null
						: referral?.contactResume,
				questionsData: referral?.questionsData || [],
				candidateQuestionsData: referral?.candidateQuestionsData || [],
				interestedQuestionsData: referral?.interestedQuestionsData || [],
				diversityHire: referral?.diversityHire || false,
				startDate: referral?.startDate,
				customStatus: referral?.customStatus,
				ownershipAtsId: referral?.ownershipAtsId,
			};
		}

		return (
			<div>
				{referral === undefined ? (
					<div className={spinContainer}>
						<Spinner company={company} />
					</div>
				) : (
					<DetailsView
						allMultiLingualData={allMultiLingualData}
						ownershipSettings={parsedOwnershipSettings}
						referral={referralData}
						employeeData={currentUser}
						history={this.props.history}
						currentUser={this.props.currentUser}
						currencyRate={currencyRate}
						currencySymbol={currencySymbol}
						deleteReferral={this.deleteReferral}
						onUpdate={this.props.onUpdateContact}
						onUpdateReferral={this.props.onUpdateReferral}
						onUpdateJob={this.props.onUpdateJob}
						onUpdateContact={this.props.onUpdateContact}
					/>
				)}
			</div>
		);
	}
}

export default withApollo(ReferralDetailsComponent);
